<template>
  <v-form v-show="isMounted" autocomplete="off">
    <v-container>

      <v-card>
            <v-card-title class="headline font-weight-regular light-blue white--text">{{InputData.Title}}</v-card-title>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr style="display:none">
                      <th style="width:50px;">No</th>
                      <th class="pl-1 pr-1">プログラム名</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in InputData.Programs" :key="index" 
                      @click="selectProgram(item.ProgramID,item.TitleFlag)"
                      v-bind:class="{ 'light-blue lighten-3' : (item.TitleFlag || false)==true ,'amber lighten-3': SelectValue.indexOf(item.ProgramID) > -1 ,'brown lighten-5':  (item.TitleFlag || false)==false && SelectValue.indexOf(item.ProgramID) == -1 }">
                      <td class="pl-0 pr-0" style="text-align:center;width:50px;"><label v-show="!!!item.TitleFlag && !!InputData.ProgramNoDisplayFlag">{{ item.ProgramTitleID }}</label><v-icon v-show="!!item.TitleFlag">mdi-file</v-icon></td>
                      <td class="pl-1 pr-1" >
                        <label class="font-weight-bold">
                        {{item.ProgramName}}
                        </label>
                        <br v-show="!!item.ProgramRemarks" />
                        <label v-html="getRemarks(item.ProgramRemarks)">
                        </label>
                      </td>
                      <td class="pl-1 pr-1" style="width:0px">
                          <v-btn v-show="!!!item.TitleFlag && isNotification" fab dark small
                            :color='!!!item.UserNotificationFlag ? "grey" : "pink" '
                            style="float: right;"
                            @click="setUserNotificationFlag(item)"
                          >
                            <v-icon dark>add_alarm</v-icon>
                          </v-btn>                        
                      </td>

                    </tr>
                </tbody>
              </template>
            </v-simple-table>        
        </v-card>

        <!-- https://www.suzu6.net/posts/52-nuxt-sns-buttons/ -->

    </v-container>

    <v-container>
        <v-btn class="icon-twitter" fab small :href="twitterUrl" target="_blank" v-show="twitterUrl.length > 0">
          <v-icon>mdi-twitter</v-icon>
        </v-btn>

        <v-btn class="icon-facebook" fab small :href="facebookUrl" target="_blank" v-show="facebookUrl.length > 0">
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
    </v-container>

  </v-form>
</template>


<style scoped>
.icon-twitter {
  margin: 5px;
  background-color: #00b0ed !important;
  color: #ffffff; 
}
.icon-facebook {
  margin: 5px;
  background-color: #2355a5 !important;
  color: #ffffff; 
}
</style>

<script>

//ヘッダーを削除＆調整 router.jsで処理

import firebase from "firebase/app";
import project from "../project.js";

const API_URL = "/api/usernotification/";

export default {
  name: "usernotification",
  mounted: async function() {
    let val = project.GetUrlVars();

    let shortKey = val["sk"];

    let okFlag = await this.getData(shortKey,true);  

    // //ブラウザ簡易通知
    // if (this.InputData.NotificationCount !=null && this.InputData.NotificationCount.length>0 ){
    //     this.isNotification = true;
    // }

    // if (this.isNotification == true){

    //   if ("Notification" in window) {
    //     let permission = Notification.permission;

    //     if (!(permission === "denied" || permission === "granted")) {
    //       Notification.requestPermission();
    //     }
    //   }
    // }

    //人数超えた場合は通知しない
    if (okFlag == true){
      this.isMounted = true;

      firebase.firestore().collection("NotificationData").doc(shortKey)
      .onSnapshot((doc) => {      
          if (doc.data() == null){
            this.SelectValue = [];

          }
          else{            
            let selectData = doc.data()["SelectValue"];

            //表示中にマスタデータを変更した場合は再読み込み
            if (selectData.length==1 && selectData.indexOf(project.RESET_DATA) > -1){
              this.SelectValue = [];
              this.getData(shortKey,false);
            }
            

            //簡易通知頑張った跡
            // if (this.isNotification == true){

            //   //チェックしているか確認
            //   let  notificationCount =  this.InputData.Programs.filter(e => 
            //             e["UserNotificationFlag"] == true
            //           ).length;

            //   if (notificationCount > 0){
            //     //差分を求める
            //     let result = selectData.filter(e => 
            //       this.SelectValue.indexOf(e) == -1
            //     );

            //     //差分があった場合
            //     if (result.length > 0){
            //       for(let i in result){
            //         //通知確認

            //         //チェックが付いたプログラムを取得
            //         let program = this.InputData.Programs.filter(e => 
            //           e["ProgramID"] == result[i]
            //         );
            //         //console.log(program);                
            //         //this.InputData.Programs[]
            //         if (program.length > 0){
                      
            //           //チェック対象のPGを取得
            //           let nextID = (+program[0]["ProgramTitleID"]) + +(this.InputData.NotificationCount) ;

            //           //ループ処理している場合は余りを取得する
            //           if ((this.InputData.LoopFlag || false )== true){
            //               let groupCount = this.InputData.Programs.filter(e => 
            //                 e["ProgramGroupID"] == program[0]["ProgramGroupID"] 
            //               ).length;

            //               nextID = nextID % groupCount;
            //               if (nextID == 0){
            //                 nextID = groupCount;
            //               }

            //           }

            //           //ユーザがチェックしたものがあるか確認
            //           let notification = this.InputData.Programs.filter(e => 
            //             e["ProgramGroupID"] == program[0]["ProgramGroupID"]  && 
            //             e["ProgramTitleID"] == nextID && 
            //             e["UserNotificationFlag"] == true
            //           );
  
            //           //存在する場合
            //           if (notification.length > 0){
            //             showNotification(notification[0]["ProgramName"] + "の時間が近づいております。");
            //           }
            //         }
                    
            //       }
            //     } //if (result.length > 0){
            //   } //if (notificationCount > 0){
            // } //if (this.isNotification == true){

            this.SelectValue = selectData;
          }        
      });

    }

  },
  data: function() {
    return {
      SelectValue : [] ,
      isMounted : false ,
      //通知するかどうか（NotificationCountから取得）
      isNotification:false,

      InputData: {
          Title: null,
          TargetDate: null,

          Programs: []
        }
    };
  },
  methods: {

    getData: async function(key,firstFlag) {

      let countUpFlag = false;

      //カウントアップするかの判定
      if (firstFlag==true){
        if (document.cookie.indexOf("dd=") == -1) {
            document.cookie = "dd=1; max-age=7200"; //max-age=  2時間 60*60*2 = 7200 一日60*60*24 = 86400
            countUpFlag =true;
        }
      }

      if (key != null){
        project.SetLoading(true);

        await project
          .PostApi(API_URL + "getData", { ShortKey: key,CountUpFlag:countUpFlag })    //認証なし
          .then(data => {          
            this.InputData = data;
          })
          .catch(e => {
            alert(e.message);
          });

        project.SetLoading(false);
      }

      if (project.IsEmpty(this.InputData) == true || this.InputData.Title == null ){
          //this.$router.push({ name: 'home'});

          let query = window.location.search;
          
          window.location.href='./confirm.html' + query
          return false;
      }
      return true;
    },


    selectProgram: async function(/*pid,titleFlag*/) {
      //関数だけ
    },

    //備考を<a>タグを付けて返す
    getRemarks: function(remarks){
        if (remarks == null || remarks.toString().length == 0){
          return ""
        }

        return AutoLink(remarks) ;
    },

    setUserNotificationFlag: function(item){
      let val =false;

      if ( (item["UserNotificationFlag"] || false) == false){
        val =true;
      }
      //よくわからないけど結局これでないと自動反映できなかった・・      
      this.$set(item, "UserNotificationFlag",val);

      //this.$forceUpdate();
      //alert(item["UserNotificationFlag"]);
    },

  },
  
computed: {
    twitterUrl : function(){
      let twitterUrl = this.InputData.TwitterUrl;
      let twitterHashtag = this.InputData.TwitterHashtag;

      if (twitterUrl==null){
        twitterUrl='';
      }

      if (twitterHashtag==null){
        twitterHashtag='';
      }

      if (twitterUrl.length == 0 && twitterHashtag.length ==0){
        return "";
      }

      if (twitterHashtag.toString().startsWith("#")){
        twitterHashtag = twitterHashtag.substr(2);
      }

      return formatByArr("https://twitter.com/intent/tweet?hashtags={0}&url={1}", twitterHashtag, twitterUrl);
    },

    facebookUrl: function(){
      let facebookID = this.InputData.FacebookID;

      if (facebookID==null){
        facebookID='';
      }      

      if (facebookID.length == 0){
        return "";
      }

      return formatByArr("https://www.facebook.com/{0}", facebookID);
    },
   
  }  
};

function AutoLink(str) {
    var regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
    var regexp_makeLink = function(all, url, h, href) {
        return '<a href="h' + href + '" target="_blank">' + url + '</a>';
    }
 
    return str.replace(regexp_url, regexp_makeLink);
}

function formatByArr(data) {
      // フォーマット（引数可変（配列）版）
      let args = [];
      for (let i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
      // URLエンコード
      args = args.map(x => encodeURIComponent(x));
      return data.replace(/\{(\d+)\}/g, function(m, k) {
        return args[k];
      });
}

//簡易通知（この方法だとブラウザがアクティブな時しか動かないので却下）
//firebase messaging を使えばバッググランドでの通知もできるが iphone未対応(2019/10/30現在)
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', function() {
//     //dummy.jsは空のファイル（public/dummy.js）
//     navigator.serviceWorker.register('../dummy.js').then(() => {
//       //alert('登録成功');
//     },() => {
//       //alert('登録失敗');
//     });
//   });
// }    

// function showNotification(title) {
//   Notification.requestPermission(function(result) {
//     if (result === 'granted') {
//       navigator.serviceWorker.ready.then(function(registration) {
//         //registration.showNotification('Vibration Sample');
//         registration.showNotification(document.title, {
//           body: title ,
//           //icon: '../images/touch/chrome-touch-icon-192x192.png',
//           //バイブ（動かない）
//           vibrate: [200, 100, 200, 100, 200, 100, 200],
//           //tag: 'vibration-sample'
//         });
//       });
//     }
//   });
// }
</script>